
<div class="file-upload">  
  <div class="container" dlAppDnd (fileDropped)="onFileDroppedandSelect($event[0])">
  <input type="file" #fileDropRef id="fileDropRef"  (change)="onFileDroppedandSelect($event.target.files[0])"  accept=".xlsx, .xls, .csv" />
  <span class="dl-svg-img"></span>
<span>Drag item here or<label for="fileDropRef">Upload</label> the file</span>     
  <!-- star -->
  <div class="files-list" *ngFor="let file of files; let i = index">
    <div class="single-file">      
      <div class="info">
        <mat-icon class="one-icons"  style="cursor: pointer; width: 21.33px;height: 26.67px;">file_excel</mat-icon>
        <span style="margin-left:20px">
        <span class="name">
          {{ file?.name }}
        </span>
        <p class="size">
          {{ formatBytes(file?.size) }}
        </p>
      </span>       
      </div>    
      <mat-icon class="one-icons" (click)="deleteFile(i)" style="cursor: pointer; width: 14px;
      height: 18px;padding-bottom: 9px;">delete_outline</mat-icon>  
    </div>
  </div>
  <!-- end -->
</div>

</div>
